import { ChangeEvent, useEffect } from 'react'
import { Stack } from '@chakra-ui/react'

import { MaskedInput } from 'components'
import { brazilianTelephoneMask } from 'utils/masks'
import validatePhoneOnCustomForm from 'components/tools/CustomForm/components/Viewer/utils/validatePhoneOnCustomForm'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import useCustomFormGetDefaultValue from '../../hooks/useCustomFormGetDefaultValue'

export default function CustomFormPhoneQuestion({
  question,
  questionKey,
  formMethods,
  disabled,
}: CustomFormViewerQuestionProps) {
  const { removeErrorFromQuestion, setErrorOnQuestion, thisQuestionHasError } = useCustomFormViewer()

  const { defaultValue } = useCustomFormGetDefaultValue({ question, questionKey, disabled })

  const questionWithError = thisQuestionHasError(question.slug)?.question

  function validateMailQuestion(phone: string) {
    const errorMessage = validatePhoneOnCustomForm({ phone, isRequired: question.is_required })
    if (errorMessage === '') {
      removeErrorFromQuestion(question.slug)
    } else {
      setErrorOnQuestion(question, errorMessage)
    }
  }

  function handleOnBlur(event: ChangeEvent<HTMLInputElement>) {
    const inputValue = event.target.value
    validateMailQuestion(inputValue)
  }

  useEffect(() => {
    if (defaultValue) {
      validateMailQuestion(defaultValue)
    }
    if (formMethods?.setValue) {
      formMethods.setValue(questionKey, defaultValue)
    }
  }, [defaultValue])
  return (
    <Stack>
      <MaskedInput
        id={question.slug}
        placeholder={question?.placeholder || 'DDD + Número'}
        isDisabled={disabled}
        mask={brazilianTelephoneMask}
        value={formMethods?.watch ? formMethods.watch(questionKey) : defaultValue}
        {...(formMethods?.register && formMethods.register(questionKey, { onBlur: handleOnBlur }))}
      />

      <CustomFormFieldErrorMessage message={questionWithError?.error_message} />
    </Stack>
  )
}
